import { render } from "./ResetPassword.vue?vue&type=template&id=849d62a0&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=849d62a0&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-849d62a0"]])

export default __exports__